import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

function DefaultRedirect() {
  const DEFAULT_COUNTRY = 'canada';
  
  // Move localStorage access to useEffect to avoid hydration mismatches
  useEffect(() => {
    // Only access localStorage after component mounts (client-side only)
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('selectedCountry', DEFAULT_COUNTRY);
    }
  }, []);
  
  // Always redirect to Canada regardless of stored country
  return <Navigate to={`country/${DEFAULT_COUNTRY}/home`} replace />;
}

export default DefaultRedirect;
